import React from 'react'
import { makeStyles } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui'

interface IInboundSftpFilesErrorProps {
  errorMessage: string | undefined | null
  /**
   * @example ['Possible error 1', 'Possible error 2']
   */
  possibleCauses: string[]
}

const useInboundSftpFilesErrorStyles = makeStyles({
  error: {
    color: brandColors.error1,
  },
})

export const InboundSftpFilesError = ({
  errorMessage,
  possibleCauses,
}: IInboundSftpFilesErrorProps) => {
  const classes = useInboundSftpFilesErrorStyles()

  return (
    <div>
      {possibleCauses.length > 0 ? (
        possibleCauses.map(cause => (
          // eslint-disable-next-line react/jsx-key
          <ul>
            <li>{cause}</li>
          </ul>
        ))
      ) : (
        <span className={classes.error}>{errorMessage}</span>
      )}
    </div>
  )
}
